__webpack_require__.p = "/crypto-staking-calculator/";